import { render, staticRenderFns } from "./GetProductsWeek.vue?vue&type=template&id=68938b53&"
import script from "./GetProductsWeek.vue?vue&type=script&lang=js&"
export * from "./GetProductsWeek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/boban/boban.adamovic.net/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68938b53')) {
      api.createRecord('68938b53', component.options)
    } else {
      api.reload('68938b53', component.options)
    }
    module.hot.accept("./GetProductsWeek.vue?vue&type=template&id=68938b53&", function () {
      api.rerender('68938b53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/GetProductsWeek.vue"
export default component.exports